import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CardModule} from 'primeng/card';
import {InputTextModule} from 'primeng/inputtext';
import {InputNumberModule} from 'primeng/inputnumber';
import {DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {ButtonModule} from 'primeng/button';
import {DividerModule} from 'primeng/divider';
import {TipoIdentificacionService} from "../../../../services/tipoIdentificacion.service";
import {IDepartamento, IMunicipio, IPais, ITipoIdentificacion} from "../../../../shared/interfaces/seguridad";
import {PaisService} from "../../../../services/pais.service";
import {MunicipioService} from "../../../../services/municipio.service";
import {DepartamentoService} from "../../../../services/departamento.service";
import {
  ITipoDiscapacidad,
  ITipoPersona,
  ITipoPoblacion,
  ITramitesDisponibles
} from "../../../../shared/interfaces/configuracion";
import {TipoDiscapacidadService} from "../../../../services/tipo-discapacidad.service";
import {TipoPersonaService} from "../../../../services/tipo-persona.service";
import {TipoPoblacionService} from "../../../../services/tipo-poblacion.service";
import {
  IDireccionLocalRequest,
  IMedioRecepcion,
  IPqrsdRequest,
  ITipoSolicitudPQRSDF
} from "../../../../shared/interfaces/pqrsdf";
import {TipoPqrsdfService} from "../../../../services/pqrsd/tipo-pqrsdf.service";
import {firstValueFrom, forkJoin, lastValueFrom, Subscription} from "rxjs";
import {DireccionesComponent} from "../../../../components/direcciones/direcciones.component";
import {DireccionesLocales, FormGroupErrorMessageComponent,
  AlertIcon,AlertService,
  LoadingPanelService, Utils} from "lib-base";
import {TipoTramiteService} from "../../../../services/tipoTramite.service";
import {RecaptchaFormsModule, RecaptchaModule} from "ng-recaptcha";
import {FileUpload, FileUploadHandlerEvent, FileUploadModule} from "primeng/fileupload";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {CheckboxModule} from "primeng/checkbox";
import {SolicitudPqrsdService} from "../../../../services/pqrsd/solicitud-pqrsd.service";
import {MedioRecepcionService} from "../../../../services/pqrsd/medio-recepcion.service";
import {MessageService} from "primeng/api";
import {ActivatedRoute, RouterLink} from "@angular/router";
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-formulario-pqrsdf',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    InputNumberModule,
    DropdownModule,
    RadioButtonModule,
    InputTextareaModule,
    ButtonModule,
    DividerModule,
    DireccionesComponent,
    RecaptchaFormsModule,
    RecaptchaModule,
    FileUploadModule,
    TranslatePipe,
    CheckboxModule,
    FormGroupErrorMessageComponent,
    RouterLink
  ],
  templateUrl: './formulario-pqrsdf.component.html',
  styleUrl: './formulario-pqrsdf.component.scss'
})
export class FormularioPqrsdfComponent implements OnInit, OnDestroy  {
  formularioPqrsdf!: FormGroup;
  tipoIdIgnore: string[] = ['TI', 'RC', 'NIT'];
  readonly ANONIMO = 3;
  readonly JURIDICA = 2;
  private readonly SI = 'SI';
  private readonly NO = 'NO';
  tiposPersona: ITipoPersona[] = [];
  _tiposIdentificacion: ITipoIdentificacion[] = [];
  private tiposIdentificacion: ITipoIdentificacion[] = [];
  private direccion: DireccionesLocales | undefined;
  private tipoSolicitud: string | undefined;
  paises: IPais [] = [];
  departamentos: IDepartamento[] = [];
  municipios: IMunicipio[] = [];
  tiposPoblacion: ITipoPoblacion[] = [];
  tiposTramites: ITramitesDisponibles[] = [];
  tiposDiscapacidad: ITipoDiscapacidad[] = [];
  tiposSolicitud: ITipoSolicitudPQRSDF[] = [];
  mediosRecepcion: IMedioRecepcion[] = [];

  opcionesSiNo : any[]=[] ;
  subscribeTipoPersona: Subscription | undefined;
  subscribePresentaDiscapacidad: Subscription | undefined;
  openDireccion:boolean = false;
  translations: any = {};
  adjunto?: File = undefined;
  readonly uploadFileSize: number = 1024 * 1024
  invalidSize = false;
  labelNotificacion: string = '';
  recaptchaIgnore: boolean = environment.recaptchaIgnore;
  basePath: string = '';

  constructor(private fb: FormBuilder,
              private tipoIdentificacionService: TipoIdentificacionService,
              private departamentoService: DepartamentoService,
              private municipioService: MunicipioService,
              private tipoDiscapacidadService: TipoDiscapacidadService,
              private tipoPersonaService: TipoPersonaService,
              private tipoPoblacionService: TipoPoblacionService,
              private tipoSolicitudService: TipoPqrsdfService,
              private tipoTramiteService: TipoTramiteService,
              private solicitudPqrsdService: SolicitudPqrsdService,
              private _lps: LoadingPanelService,
              private messageService: MessageService,
              private medioRecepcionService: MedioRecepcionService,
              private _ar: ActivatedRoute,
              private _t: TranslateService,
              private alertService:AlertService,
              private paisService: PaisService) {
    this.tipoSolicitud = this._ar.snapshot.params['tipo'] ?? undefined;

    this.initForm();
  }

  async ngOnInit() {
    await this.initTranslations().then(
      () => this.getOpcionesSiNo()
    );
    this.getTipoIdentificaciones()
      .then(() => this.filterTipoIdentificacion(1));
    this.getPaises();

    this.getTipoPersonas();
    this.getTipoPoblaciones();
    this.getTipoDiscapacidad();
    this.getTipoSolicitudes();
    this.getTramites();
    this.getMediosRecepcion();

    this.changeHasDiscapacidad();
    this.changeTipoPersona();
    this._ar.parent?.url.subscribe((url) => {
      this.basePath = url[0]?.path;
    });
  }

  ngOnDestroy(): void {
    this.subscribePresentaDiscapacidad?.unsubscribe();
    this.subscribeTipoPersona?.unsubscribe();
  }

  initForm() {
    this.formularioPqrsdf = this.fb.group({
      tipoPersona: [1, Validators.required],
      identificacion: ['', Validators.required],
      numeroIdentificacion: [null, Validators.required],
      primerNombre: ['', Validators.required],
      razonSocial: [''],
      segundoNombre: [''],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      pais: [null, Validators.required],
      departamento: [null, Validators.required],
      municipio: [null, Validators.required],
      tipoPoblacion: [null, Validators.required],
      direccion: ['', Validators.required],
      telefono: ['', Validators.required],
      presentaDiscapacidad: [null],
      discapacidad: [null],
      correoElectronico: ['', [Validators.required, Validators.email]],
      tipoSolicitud: [null, Validators.required],
      temaSolicitud: ['',[ Validators.required]],
      descripcionSolicitud: ['', [Validators.required]],
      tramite: [null],
      medioRecepcion: [null, Validators.required],
      notificacion: [null, Validators.required],
      recaptchaReactive: [null, [Validators.required]],
      politicaDatos: [null, [Validators.required]],

    });

    this.formularioPqrsdf.get('discapacidad')?.disable();
  }

  changeTipoPersona() {
    this.subscribeTipoPersona = this.formularioPqrsdf.get('tipoPersona')?.valueChanges.subscribe(value => {
      if (value == this.ANONIMO) {
        this.desactivarCamposPersonales();
      } else if (value == this.JURIDICA) {
        this.activarCamposPersonalesJuridica();
      } else {
        this.activarCamposPersonales();
        this.desactivarCamposPersonales(['razonSocial']);
      }
      this.filterTipoIdentificacion(value);
    });
  }

  changeHasDiscapacidad() {
    this.subscribePresentaDiscapacidad = this.formularioPqrsdf.get('presentaDiscapacidad')?.valueChanges.subscribe(value => {
      const discapacidadControl = this.formularioPqrsdf.get('discapacidad');
      if (value === this.SI) {
        discapacidadControl?.enable();
        discapacidadControl?.setValidators(Validators.required);
      } else {
        discapacidadControl?.clearValidators();
        discapacidadControl?.reset();
        discapacidadControl?.disable();
      }
      discapacidadControl?.updateValueAndValidity();
    });
  }

  activarCamposPersonalesJuridica() {
    const enable = [
      'identificacion', 'numeroIdentificacion', 'razonSocial',
      'departamento', 'municipio', 'tipoPoblacion', 'direccion',
      'telefono', 'presentaDiscapacidad'
    ];
    const disabled = ['primerNombre', 'primerApellido', 'segundoNombre', 'segundoApellido'];
    this.activarCamposPersonales(enable);
    this.desactivarCamposPersonales(disabled);
  }

  desactivarCamposPersonales(value?:string[]) {
    const campos = (value ) ? value
      : [ 'primerNombre', 'segundoNombre', 'primerApellido', 'segundoApellido',
      'identificacion', 'numeroIdentificacion', 'departamento', 'municipio',
      'tipoPoblacion', 'direccion', 'telefono', 'presentaDiscapacidad', 'razonSocial'
    ];

    campos.forEach(campo => {
      this.formularioPqrsdf.get(campo)?.disable();
      this.formularioPqrsdf.get(campo)?.reset();
      this.formularioPqrsdf.get(campo)?.clearValidators();
      this.formularioPqrsdf.get(campo)?.updateValueAndValidity();
    });
  }

  activarCamposPersonales( value ?: string[]) {
    const campos = (value) ? value : [
      'primerNombre', 'primerApellido', 'segundoNombre', 'segundoApellido',
      'identificacion', 'numeroIdentificacion',
      'departamento', 'municipio', 'tipoPoblacion', 'direccion',
      'telefono'
    ];

    campos.forEach(campo => {
      this.formularioPqrsdf.get(campo)?.enable();
      this.formularioPqrsdf.get(campo)?.setValidators(Validators.required);
      if (campo == 'correoElectronico') this.formularioPqrsdf.get(campo)?.addValidators(Validators.email)
      this.formularioPqrsdf.get(campo)?.updateValueAndValidity();
    });

    // Campos sin validador required
    const camposSinRequerido = ['segundoNombre', 'segundoApellido','presentaDiscapacidad' ];
    camposSinRequerido.forEach(campo => {
      this.formularioPqrsdf.get(campo)?.enable();
      this.formularioPqrsdf.get(campo)?.clearValidators();
      this.formularioPqrsdf.get(campo)?.updateValueAndValidity();
    });

    // Actualizar validación para discapacidad
    if (this.formularioPqrsdf.get('presentaDiscapacidad')?.value === this.SI) {
      this.formularioPqrsdf.get('discapacidad')?.enable();
      this.formularioPqrsdf.get('discapacidad')?.setValidators(Validators.required);
    } else {
      this.formularioPqrsdf.get('discapacidad')?.disable();
      this.formularioPqrsdf.get('discapacidad')?.clearValidators();
    }
    this.formularioPqrsdf.get('discapacidad')?.updateValueAndValidity();
  }

  onchangePais(id: number) {
    this.getDepartamentos(id);
    this.formularioPqrsdf.get('departamento')?.reset();
    this.formularioPqrsdf.get('departamento')?.enable();
    this.formularioPqrsdf.get('municipio')?.reset();
    this.municipios = []
  }

  onChangeDepartamento(departamento: IDepartamento) {
    const paisId = this.formularioPqrsdf.get('pais')?.value;
    this.getMunicipiosByDepartamento(paisId, departamento.id);
    this.formularioPqrsdf.get('municipio')?.reset();
    if (!this.isOtroDepartamento){
      this.formularioPqrsdf.get('municipio')?.enable();
      this.formularioPqrsdf.get('discapacidad')?.setValidators(Validators.required);
    }else{
      this.formularioPqrsdf.get('municipio')?.disable();
      this.formularioPqrsdf.get('municipio')?.clearValidators();
    }
    this.formularioPqrsdf.get('municipio')?.updateValueAndValidity();

  }

  filterTipoIdentificacion(value: number) {
    this._tiposIdentificacion = this.tiposIdentificacion?.filter((it) => {
      if (![this.JURIDICA, this.ANONIMO].includes(value)) {
        return !this.tipoIdIgnore.includes(it.abreviatura);
      } else if (value == this.JURIDICA) {
        return it.abreviatura == this.tipoIdIgnore[2];
      }
      return true;
    })
  }

  changeDireccion(value: DireccionesLocales) {
    this.formularioPqrsdf.get('direccion')?.setValue(value.direccionTextual);
    this.direccion = value;
  }

  resetForm() {
    this.formularioPqrsdf.reset();
    this.formularioPqrsdf.get('tipoPersona')?.setValue(1);
    this.activarCamposPersonales();
    this.removeFile();
    this.initFieldTipoSolicitud();
    this.changeMedioRecepcion(null);
  }

  initFieldTipoSolicitud() {
     if (this.tiposSolicitud && this.tiposSolicitud.length  && this.tipoSolicitud) {
      const tipo = this.tiposSolicitud.find(t => t.descripcion === this.tipoSolicitud);
      if (tipo) {
        this.formularioPqrsdf.get('tipoSolicitud')?.setValue(tipo.id);
      }
    }
  }

  uploadHandler(event: FileUploadHandlerEvent, fileUpload: FileUpload) {
    const file = event.files[0];
    this.invalidSize = false;
    //validate file size
    if (file.size > this.uploadFileSize) {
      this.invalidSize = true;
      fileUpload.clear();
      return;
    }
    this.adjunto = file;
    fileUpload.clear();
  }

  removeFile() {
    this.adjunto = undefined;
    this.invalidSize = false;
  }

  private async initTranslations() {
    this.translations = await firstValueFrom(forkJoin({
      buttonAceptar: this._t.get('form.button.submit'),
      buttonLimpiar: this._t.get('form.button.limpiar'),
      titulo: this._t.get('components.app-formulario-pqrsd.titulo'),
      subtitulo: this._t.get('components.app-formulario-pqrsd.subtitulo'),
      seccionInfoPersonal: this._t.get('components.app-formulario-pqrsd.seccion-informacion-personal'),
      seccionInfoSolicitud: this._t.get('components.app-formulario-pqrsd.seccion-informacion-solicitud'),
      seccionRecepcionRespuesta: this._t.get('components.app-formulario-pqrsd.seccion-recepcion-respuesta'),
      tipoPersona: this._t.get('components.app-formulario-pqrsd.tipo-persona'),
      tipoIdentificacion: this._t.get('components.app-formulario-pqrsd.tipo-identificacion'),
      tipoIdentificacionPlaceholder: this._t.get('components.app-formulario-pqrsd.tipo-identificacion-placeholder'),
      numeroIdentificacion: this._t.get('components.app-formulario-pqrsd.numero-identificacion'),
      primerNombre: this._t.get('components.app-formulario-pqrsd.primer-nombre'),
      razonSocial: this._t.get('components.app-formulario-pqrsd.razon-social'),
      segundoNombre: this._t.get('components.app-formulario-pqrsd.segundo-nombre'),
      primerApellido: this._t.get('components.app-formulario-pqrsd.primer-apellido'),
      segundoApellido: this._t.get('components.app-formulario-pqrsd.segundo-apellido'),
      telefono: this._t.get('components.app-formulario-pqrsd.telefono'),
      correo: this._t.get('components.app-formulario-pqrsd.correo-electronico'),
      direccion: this._t.get('components.app-formulario-pqrsd.direccion'),
      pais: this._t.get('components.app-formulario-pqrsd.pais'),
      paisPlaceholder: this._t.get('components.app-formulario-pqrsd.pais-placeholder'),
      departamento: this._t.get('components.app-formulario-pqrsd.departamento'),
      deparamentoPlaceholder: this._t.get('components.app-formulario-pqrsd.departamento-placeholder'),
      municipio: this._t.get('components.app-formulario-pqrsd.municipio'),
      municipioPlaceholder: this._t.get('components.app-formulario-pqrsd.municipio-placeholder'),
      tipoPoblacion: this._t.get('components.app-formulario-pqrsd.tipo-poblacion'),
      tipoPoblacionPlaceholder: this._t.get('components.app-formulario-pqrsd.tipo-poblacion-placeholder'),
      discapacidad: this._t.get('components.app-formulario-pqrsd.discapacidad'),
      discapacidadPlaceholder: this._t.get('components.app-formulario-pqrsd.discapacidad-placeholder'),
      presentaDiscapacidad: this._t.get('components.app-formulario-pqrsd.presenta-discapacidad'),
      presentaDiscapacidadPlaceholder: this._t.get('components.app-formulario-pqrsd.presenta-discapacidad-placeholder'),
      tipoSolicitud: this._t.get('components.app-formulario-pqrsd.tipo-solicitud'),
      tipoSolicitudPlaceholder: this._t.get('components.app-formulario-pqrsd.tipo-solicitud-placeholder'),
      tramite: this._t.get('components.app-formulario-pqrsd.tramite'),
      tipoTramitePlaceholder: this._t.get('components.app-formulario-pqrsd.tramite-placeholder'),
      temaSolicitud: this._t.get('components.app-formulario-pqrsd.tema-solicitud'),
      descripcionSolicitud: this._t.get('components.app-formulario-pqrsd.descripcion-solicitud'),
      medioRecepcion: this._t.get('components.app-formulario-pqrsd.medio-recepcion'),
      medioRecepcionPlaceholder: this._t.get('components.app-formulario-pqrsd.medio-recepcion-placeholder'),
      medioNotificacion: this._t.get('components.app-formulario-pqrsd.medio-notificacion'),
      politicaDatos: this._t.get('components.app-formulario-pqrsd.politica-datos'),
      estoyDeAcuerdo: this._t.get('components.app-formulario-pqrsd.estoy-de-acuerdo'),
      SI: this._t.get('components.app-formulario-pqrsd.si'),
      NO: this._t.get('components.app-formulario-pqrsd.no'),
      volver:this._t.get('form.button.atras'),

      warnSummary:this._t.get('form.msg.warn-summary'),
      completeCampos:this._t.get('form.msg.complete-campos'),
      verifyCaptcha:this._t.get('form.msg.verify-captcha'),
      warnPoliticaDatos:this._t.get('form.msg.politica-datos'),

    }));
    this.labelNotificacion = this.translations.medioNotificacion;
  }

  changeMedioRecepcion(value:number | null){
    if (value && this.mediosRecepcion) {
      const medioRecepcion = this.mediosRecepcion
        .find(i => i.id === value)?.descripcion ?? '';
      this.labelNotificacion = this.translations.medioNotificacion + ' ' + medioRecepcion?.toLowerCase();
    } else {
      this.labelNotificacion = this.translations.medioNotificacion;
    }
  }

  //Call API

  async getTipoIdentificaciones() :Promise<void> {
    return await lastValueFrom(this.tipoIdentificacionService.getTipoIdentificaciones()).then(
      (response: ITipoIdentificacion[]) => {
        this.tiposIdentificacion = response;
      });
  }

  getOpcionesSiNo() {
    this.opcionesSiNo = [
      {label: this.translations.SI, value: this.SI},
      {label: this.translations.NO, value: this.NO}
    ];
  }

  getPaises() {
    this.paisService.getPaises().subscribe({
      next: (response: IPais[]) => {
        this.paises = response;
      }, error: (error) => {
        console.error('Error al obtener los paises:', error);
      }
    })
  }

  getDepartamentos(paisId: number) {
    this.departamentoService.getDepartamentos(paisId).subscribe({
      next: (response: IDepartamento[]) => {
        this.departamentos = response;
      }, error: (error) => {
        console.error('Error al obtener los departamentos:', error);
      }
    })
  }

  getMunicipiosByDepartamento(pais: number, departamentoId: number) {
    this.municipioService.getMunicipios(pais, departamentoId).subscribe({
      next: (response: IMunicipio[]) => {
        this.municipios = response;
      }, error: (error) => {
        console.error('Error al obtener los municipios:', error);
      }
    });
  }

  getTipoPoblaciones() {
    this.tipoPoblacionService.getAll().subscribe({
      next: (response: ITipoPoblacion[]) => {
        this.tiposPoblacion = response;
      }, error: (error) => {
        console.error('Error al obtener los tipos de poblacion:', error);
      }
    })
  }

  getTipoPersonas() {
    this.tipoPersonaService.getAll().subscribe({
      next: (response: ITipoPersona[]) => {
        this.tiposPersona = response;
      }, error: (error) => {
        console.error('Error al obtener los tipos de persona:', error);
      }
    })
  }

  getTipoDiscapacidad() {
    this.tipoDiscapacidadService.getAll().subscribe({
      next: (response: ITipoDiscapacidad[]) => {
        this.tiposDiscapacidad = response;
      }, error: (error) => {
        console.error('Error al obtener los tipos de discapacidad:', error);
      }
    })
  }

  getTipoSolicitudes() {
    this.tipoSolicitudService.getAll().subscribe({
      next: (response: ITipoSolicitudPQRSDF[]) => {
        this.tiposSolicitud = response;
        this.initFieldTipoSolicitud();
      }, error: (error) => {
        console.error('Error al obtener los tipos de solicitud:', error);
      }
    });
  }

  getTramites(){
    this.tipoTramiteService.getAllTramitesDisponibles().subscribe({
      next: (response:ITramitesDisponibles []) => {
        this.tiposTramites = response;
      }
    })
  }

  getMediosRecepcion() {
    this.medioRecepcionService.getAll().subscribe({
      next:(response) => {
        this.mediosRecepcion = response;
      }
    })
  }

  enviarFormulario() {
    if(this.recaptchaIgnore){
      this.formularioPqrsdf.get('recaptchaReactive')?.setValue('ignore')
    }
    if (this.formularioPqrsdf.invalid) {
      Utils.markAllFormControlsAsTouched(this.formularioPqrsdf);
      if (this.formularioPqrsdf.get('politicaDatos')?.invalid) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.warnSummary, detail: this.translations.warnPoliticaDatos
        });
      } else if (this.formularioPqrsdf.get('recaptchaReactive')?.invalid) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.warnSummary, detail: this.translations.verifyCaptcha
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.warnSummary, detail: this.translations.completeCampos
        });
      }
      return;
    }
    this._lps.show();
    const request = this.buildRequest();
    if (!request) return;
    this.solicitudPqrsdService.crearSolicitud(request, this.adjunto).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this.finishSolicitud(response);
      }, error: (error) => {
        this._lps.hide();
      }
    })
  }

  buildDireccion(): IDireccionLocalRequest | null {
    if (!this.direccion) return null;
    return {
      barrio: this.direccion.barrio,
      direccionTextual: this.direccion.direccionTextual,
      literalesByViaGeneradoraLiteral: this.direccion.literalesByViaGeneradoraLiteral?.literal ?? null,
      literalesByViaPrincipalBisLiteral: this.direccion.literalesByViaPrincipalBisLiteral?.literal ?? null,
      literalesByViaPrincipalLiteral: this.direccion.literalesByViaPrincipalLiteral?.literal ?? null,
      literalesByTipoViaGeneradora: this.direccion.literalesByTipoViaGeneradora?.literal ?? null,
      literalesByViaGeneradoraCard: this.direccion.literalesByViaGeneradoraCard?.literal ?? null,
      literalesByViaPrincipalCard: this.direccion.literalesByViaPrincipalCard?.literal ?? null,
      literalesByViaPrincipalBis: this.direccion.literalesByViaPrincipalBis?.literal ?? null,
      literalesByTipoViaPrincipal: this.direccion.literalesByTipoViaPrincipal?.literal ?? null,
      viaGeneradora: this.direccion.viaGeneradora,
      viaPrincipal: this.direccion.viaPrincipal,
      nomenclatura: this.direccion.nomenclatura,
      observacion: this.direccion.observacion,
      complementos: this.direccion?.direccionLocalComplementos?.map(complemento => ({
        literal: complemento.literales.literal,
        orden: complemento.orden,
        descripcion: complemento.descripcion
      })) ?? null
    } as IDireccionLocalRequest;
  }

  buildRequest(): IPqrsdRequest | null {
    if (this.formularioPqrsdf.invalid) return null;
    const direccion = this.buildDireccion();
    return {
      descripcion: this.formularioPqrsdf.get('descripcionSolicitud')?.value,
      tema: this.formularioPqrsdf.get('temaSolicitud')?.value,
      tipo: this.formularioPqrsdf.get('tipoSolicitud')?.value,
      tipoTramite: this.formularioPqrsdf.get('tramite')?.value?.tramiteId ?? null,
      captchaToken: this.formularioPqrsdf.get('recaptchaReactive')?.value,
      ciudadano: {
        tipoPersona: this.formularioPqrsdf.get('tipoPersona')?.value,
        tipoIdentificacion: this.formularioPqrsdf.get('identificacion')?.value?.id ?? null,
        identificacion: this.formularioPqrsdf.get('numeroIdentificacion')?.value,
        primerNombre: this.formularioPqrsdf.get('primerNombre')?.value,
        razonSocial: this.formularioPqrsdf.get('razonSocial')?.value,
        segundoNombre: this.formularioPqrsdf.get('segundoNombre')?.value,
        primerApellido: this.formularioPqrsdf.get('primerApellido')?.value,
        segundoApellido: this.formularioPqrsdf.get('segundoApellido')?.value,
        pais: this.formularioPqrsdf.get('pais')?.value,
        departamento: this.formularioPqrsdf.get('departamento')?.value?.id ?? null,
        municipio: this.formularioPqrsdf.get('municipio')?.value,
        tipoPoblacion: this.formularioPqrsdf.get('tipoPoblacion')?.value?.id ?? null,
        direccionLocal: direccion,
        correo: this.formularioPqrsdf.get('correoElectronico')?.value,
        telefono: this.formularioPqrsdf.get('telefono')?.value,
        tipoDiscapacidad: this.formularioPqrsdf.get('discapacidad')?.value,
      },
      medioRecepcion: this.formularioPqrsdf.get('medioRecepcion')?.value,
      medioNotificacion: this.formularioPqrsdf.get('notificacion')?.value
    } as IPqrsdRequest;
  }


  // end Call Api

  finishSolicitud(radicado?:string ) {
    this.alertService.show({
      data: {
        showIcon: true,
        icon: AlertIcon.SUCCESS,
        title: 'Solicitud enviada',
        html: `<h2 class="text-2xl text-black">Su solicitud
                <span class="text-blue-general"> ${radicado}</span>
        ha sido enviada exitosamente.</h2>`,
        showAccept: true,
      },
      acceptButton:{
        label: this.translations.buttonAceptar,
        class: 'border-rounded-xl bg-indigo-600 hover:bg-indigo-400',
      },
      autoClose: true,
      timer: 3500
    });
    this.resetForm();
  }

  get tipoPersona(): number {
    return this.formularioPqrsdf.get('tipoPersona')?.value;
  }

  get isAnonimo():boolean {
    return  this.tipoPersona == this.ANONIMO;
  }
  get isOtroDepartamento() {
    return this.formularioPqrsdf.get('departamento')?.value?.descripcion === "OTRO";
  }
}
